import { CONTRACT_VERSION } from 'sfx-web-contract/version';
import { OFX_WEB } from '../../helpers/app-config';

const convertNumberToLittleEndianByte = (length: number) => Uint8Array
    .from([ (length << 24), (length << 16), (length << 8), length ]
        .map(nb => nb >>> 24));

/**
 * The function will prefix the data array with its length in little-endian byte.
 * Sample:
 * - Input [10, 11, 12, 13],
 *   So, length (4 here) become [4, 0, 0, 0]
 *   Then, output will be [4, 0, 0, 0, 10, 11, 12, 13].
 */
export function addLengthHeader(arr: Uint8Array): Uint8Array {
    const header = convertNumberToLittleEndianByte(arr.length);

    const result = new Uint8Array(arr.length + header.length);
    result.set(header);
    result.set(arr, header.length);

    return result;
}

export function getConnectionURL(): string {
    return [
        OFX_WEB.PROTOCOL,
        '://',
        OFX_WEB.GATEWAY_ADDRESS,
        ':',
        OFX_WEB.PORT,
        '/',
        OFX_WEB.WEB_SOCKET_URL,
        '?contract=',
        CONTRACT_VERSION,
    ].join('');
}
